{
  "language": {
    "name": "ภาษาไทย",
    "title": "ภาษา"
  },
  "format": {
    "currency": "{{value, currency(currency: USD)}}",
    "number": "{{value, number(maximumFractionDigits: 9)}}"
  },
  "button": {
    "auto": "อัตโนมัติ",
    "bridge": "บริดจ์",
    "buy": "ซื้อ",
    "buyNow": "ซื้อตอนนี้",
    "cancel": "ยกเลิก",
    "connectWallet": "เชื่อมต่อ กระเป๋า",
    "contactSupport": "ติดต่อฝ่ายสนับสนุน",
    "continue": "ดำเนินการต่อ",
    "copyAddress": "คัดลอกที่อยู่",
    "dark": "มืด",
    "delete": "ลบ",
    "disconnect": "ยกเลิกการเชื่อมต่อ",
    "done": "เสร็จสิ้น",
    "exchange": "แลกเปลี่ยน",
    "getGas": "รับแก็ส",
    "hide": "ซ่อน",
    "learnMore": "เรียนรู้เพิ่มเติม",
    "lifiCheckout": "Li.Fi. ตรวจสอบ",
    "lifiExchange": "LI.FI Exchange",
    "light": "สว่าง",
    "max": "สูงสุด",
    "ok": "ตกลง",
    "removeTransaction": "นำรายการออก",
    "reset": "ล้างข้อมูล",
    "resetSettings": "รีเซ็ตการตั้งค่า",
    "reviewBridge": "ตรวจสอบบริดจ์",
    "reviewPurchase": "ตรวจสอบการสั่งซื้อ",
    "reviewSwap": "ตรวจสอบการแลกเปลี่ยน",
    "seeDetails": "ดูรายละเอียด",
    "showAll": "แสดงทั้งหมด",
    "startBridging": "เริ่มต้นการบริดจ์",
    "startSwapping": "เริ่มต้นการแลกเปลี่ยน",
    "swap": "การแลกเปลี่ยน",
    "tryAgain": "ลองใหม่",
    "viewCoverage": "ดูความคุ้มครอง",
    "viewOnExplorer": "ดูในการสำรวจ"
  },
  "header": {
    "activeTransactions": "ธุรกรรมมีผล",
    "bridge": "บริดจ์",
    "checkout": "เช็คเอาท์",
    "exchange": "แลกเปลี่ยน",
    "from": "แลกเปลี่ยนจาก",
    "gas": "แก็ส",
    "payWith": "ชำระด้วย",
    "purchase": "ซื้อ",
    "purchaseDetails": "รายละเอียดการซื้อ",
    "selectChain": "เลือกเชน",
    "selectWallet": "เลือกกระเป๋าของคุณ",
    "settings": "ตั้งค่า",
    "swap": "แลกเปลี่ยน",
    "to": "แลกเปลี่ยนเป็น",
    "transactionDetails": "รายละเอียดของธุรกรรม",
    "transactionHistory": "ประวัติการซื้อขาย",
    "walletConnected": "กระเป๋าถูกเชื่อมต่อแล้ว",
    "youGet": "คุณได้รับ"
  },
  "info": {
    "message": {
      "autoRefuel": "คุณใช้แก็ส {{chainName}} เหลือน้อย เมื่อดำเนินการต่อ คุณจะได้รับแก็สเพียงพอสำหรับการแลกเปลี่ยนให้เสร็จสมบูรณ์",
      "emptyActiveTransactions": "การแลกเปลี่ยนที่กำลังดำเนินการจะปรากฏที่นี่. เมื่อเสร็จสิ้น, จะพบประวัติการแลกเปลี่ยน.",
      "emptyTokenList": "เราไม่พบโทเค็นใน {{chainName}} เชนหรือคุณไม่มีโทเค็น. โปรดลองอีกครั้งหรือเลือกเชนอื่น.",
      "emptyTransactionHistory": "ประวัติการแลกเปลี่ยนจะถูกเก็บไว้ในเครื่องเท่านั้นและจะถูกลบหากคุณล้างข้อมูลเบราว์เซอร์ของคุณ.",
      "routeNotFound": "เหตุผลที่อาจเกิดขึ้น : สภาพคล่องต่ำ , จำนวนที่เลือกน้อยเกินไป , ต้นทุนแก็สสูงหรือไม่มีเส้นทางที่ใช้งานได้"
    },
    "title": {
      "autoRefuel": "รับแก็ส",
      "emptyActiveTransactions": "ไม่มีธุรกรรมที่มีผล",
      "emptyTransactionHistory": "ไม่มีธุรกรรมล่าสุด",
      "routeNotFound": "ไม่พบเส้นทาง"
    }
  },
  "success": {
    "message": {
      "exchangePartiallySuccessful": "เราได้พยายามดำเนินการแลกเปลี่ยนให้เสร็จสมบูรณ์แต่ {{tool}} ขาดสภาพคล่องสำหรับโทเค็น {{tokenSymbol}}",
      "exchangeSuccessful": "ตอนนี้มี {{amount, number(maximumFractionDigits: 9)}}{{tokenSymbol}} ใน {{walletAddress}} กระเป๋าบน {{chainName}} เชน.",
      "purchaseSuccessful": "คุณมี {{assetName}} ใน{{walletAddress}} กระเป๋า บน{{chainName}} เครือข่าย"
    },
    "title": {
      "bridgePartiallySuccessful": "แลกเปลี่ยนสำเร็จบางส่วน",
      "bridgeSuccessful": "บริดจ์สำเร็จ",
      "purchaseSuccessful": "การซื้อเสร็จสมบูรณ์",
      "refundIssued": "คืนเงินแล้ว",
      "swapPartiallySuccessful": "แลกเปลี่ยนสำเร็จบางส่วน",
      "swapSuccessful": "แลกเปลี่ยนสำเร็จ"
    }
  },
  "warning": {
    "message": {
      "deleteActiveTransactions": "การแลกเปลี่ยนที่ใช้งานอยู่จะถูกจัดเก็บไว้ในเครื่องเท่านั้นและไม่สามารถกู้คืนได้หากคุณลบออก.",
      "deleteTransactionHistory": "ประวัติการแลกเปลี่ยนจะถูกจัดเก็บไว้ในเครื่องเท่านั้นและไม่สามารถกู้คืนได้หากคุณลบออก",
      "highValueLoss": "มูลค่าของโทเค็นที่ได้รับนั้นต่ำกว่าโทเค็นที่แลกเปลี่ยนและต้นทุนการทำธุรกรรมอย่างมาก.",
      "insufficientFunds": "คุณมีเงินไม่เพียงพอที่จะดำเนินการแลกเปลี่ยน.",
      "insufficientGas": "คุณมีแก๊สไม่เพียงพอที่จะแลกเปลี่ยนให้เสร็จสมบูรณ์ คุณต้องเพิ่มอย่างน้อย:",
      "rateChanged": "อัตราแลกเปลี่ยนมีการเปลี่ยนแปลง คุณจะยอมรับอัตราใหม่.",
      "resetSettings": "การดำเนินการนี้จะรีเซ็ตลำดับความสำคัญของเส้นทาง การคลาดเลื่อน ค่าแก็ส บริดจ์ที่เปิดใช้งานและการแลกเปลี่ยน"
    },
    "title": {
      "deleteActiveTransactions": "ลบ​รายการธุรกรรม​ทั้งหมด?",
      "deleteTransaction": "ต้องการลบธุรกรรมนี้?",
      "deleteTransactionHistory": "ต้องการลบประวัติการทำธุรกรรม?",
      "highValueLoss": "สูญเสียมูลค่าสูง",
      "insufficientGas": "ค่าแก็สไม่พอ",
      "rateChanged": "อัตราการแลกเปลี่ยนถูกเปลี่ยน",
      "resetSettings": "รีเซ็ทการตั้งค่า?"
    }
  },
  "error": {
    "message": {
      "allowanceRequired": "โอนด้วยจำนวน {{tokenSymbol}} ตามการอนุญาตของคุณ.ได้โปรดเพิ่มการอนุญาตของคุณอีกครั้ง",
      "insufficientFunds": "คุณมีแก็สไม่พอสำหรับการธุรกรรมนี้",
      "slippageThreshold": "การคลาดเคลื่อนมีขนาดใหญ่กว่าเกณฑ์ที่กำหนด โปรดขอเส้นทางใหม่เพื่อได้รับการเสนอราคาใหม่.",
      "transactionFailed": "โปรดตรวจสอบบล็อกการสำรวจสำหรับข้อมูลเพิ่มเติม.",
      "transactionNotSent": "ไม่ได้ส่งธุรกรรม. {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} บน {{chainName}} ยังคงอยู่ในกระเป๋าเงินของคุณ.",
      "transactionRejected": "จำเป็นต้องมีลายเซ็นของคุณเพื่อทำธุรกรมให้เสร็จสมบูรณ์. {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} บน {{chainName}} ยังคงอยู่ในกระเป๋าเงินของคุณ.",
      "unknown": "โปรดลองอีกครั้งหรือติดต่อฝ่ายสนับสนุน."
    },
    "title": {
      "allowanceRequired": "การอนุญาตไม่เพียงพอ",
      "balanceIsTooLow": "ยอดคงเหลือต่ำเกินไป",
      "chainSwitch": "จำเป็นต้องเปลี่ยนเชน",
      "gasLimitIsTooLow": "แก๊สคงเหลือต่ำเกินไป",
      "insufficientFunds": "ยอดคงเหลือไม่เพียงพอ",
      "slippageNotMet": "ความคลาดเคลื่อนของราคาไม่เป็นไปตามเงื่อนไข.",
      "transactionCanceled": "ธุรกรรมถูกยกเลิกแล้ว",
      "transactionFailed": "การทำธุรกรรมล้มเหลว",
      "transactionRejected": "ต้องมีลายเซ็น",
      "transactionUnderpriced": "ราคาธุรกรรมต่ำเกินไป",
      "transactionUnprepared": "ไม่สามารถจัดทำธุรกรรมได้",
      "unknown": "มีบางอย่างผิดพลาด",
      "walletAddressInvalid": "ที่อยู่กระเป๋าเงินไม่ถูกต้อง.",
      "walletAddressRequired": "กรุณากรอกที่อยู่กระเป๋าเงิน.",
      "walletEnsAddressInvalid": "ที่อยู่กระเป๋าเงินไม่ถูกต้องหรือเครือข่ายไม่รองรับ ENS."
    }
  },
  "tooltip": {
    "additionalProviderFee": "บริดจ์เพิ่มเติม DEX และค่าบริการ",
    "estimatedNetworkFee": "ค่าธรรรมเนียมโดยประมาณของเครือข่าย",
    "estimatedTime": "เวลาดำเนินการแลกเปลี่ยนโดยประมาณเป็นนาที.",
    "notFound": {
      "text": "เราไม่พบหน้านี้.",
      "title": "404"
    },
    "numberOfSteps": "ขั้นตอนการแลกเปลี่ยนหลายขั้นตอน แต่ละขั้นตอนสามารถมี 1-2 รายการที่ต้องใช้ลายเซ็น.",
    "progressToNextUpdate": "ข้อมูลที่แสดงจะรีเฟรชอัตโนมัติหลังจาก {{value}} วินาที คลิกที่นี่เพื่ออัปเดตด้วยตนเอง",
    "recommended": "เส้นทางที่ถูกมียอดคงเหลือที่เพียงพอและง่ายต่องการใช้งาน",
    "settingsModified": "การตั้งค่า (แก้ไข)"
  },
  "main": {
    "crossStepDetails": "บริดจ์จาก{{from}} to {{to}} โดย {{tool}}",
    "currentAmount": "จำนวนเงินปัจจุบัน",
    "estimatedTime": "{{value}} นาที",
    "featuredTokens": "จุดเด่นของเหรียญ",
    "from": "จาก",
    "fromAmount": "คุณจ่าย",
    "gasCost": "ค่าแก๊ส",
    "gasFeeEstimated": "ค่าแก๊สโดยประมาณ",
    "gasFeePaid": "จ่ายค่าทำเนียมแล้ว",
    "inProgress": "กำลังดำเนินการ",
    "nftStepDetails": "ซื้อ NFT ผ่าน {{tool}}",
    "onChain": "บน {{chainName}}",
    "otherTokens": "โทเค็นอื่น",
    "ownedBy": "เป็นเจ้าของโดย",
    "process": {
      "crossChain": {
        "actionRequired": "กรุณาเซ็นชื่อในการทำธุรกรรม",
        "done": "ธุรกรรมข้ามเชนได้รับการยืนยันแล้ว",
        "pending": "รอสำหรับการทำรายการบริดจ์",
        "started": "เตรียมการทำรายการบริดจ์"
      },
      "nft": {
        "done": "ซื้อ NFT แล้ว"
      },
      "receivingChain": {
        "done": "ข้ามเชนเสร็จสมบูรณ์",
        "partial": "การข้ามเชนเสร็จสมบูรณ์บางส่วน",
        "pending": "กำลังรอเชนปลายทาง",
        "refunded": "คืนเงินการทำธุรกรรมข้ามเชนแล้ว"
      },
      "swap": {
        "actionRequired": "กรุณาเซ็นชื่อในการทำธุรกรรม",
        "done": "การแลกเปลี่ยนเสร็จสมบูรณ์",
        "pending": "กำลังรอการแลกเปลี่ยนธุรกรรม",
        "started": "กำลังเตรียมการแลกเปลี่ยนธุรกรรม"
      },
      "switchChain": {
        "actionRequired": "จำเป็นต้องเปลี่ยนเชน",
        "done": "สลับเชนสำเร็จแล้ว"
      },
      "tokenAllowance": {
        "done": "โทเค็นได้รับการอนุญาตแล้ว",
        "pending": "รอการอนุญาตของโทเค็น",
        "started": "การตั้งค่าการอนุญาตโทเค็น"
      }
    },
    "quotedAmount": "จำนวนทั้งหมดที่เสนอ",
    "rateChange": "อัตราแลกเปลี่ยน",
    "receiving": "ได้รับ",
    "refuelStepDetails": "รับแก๊สผ่าน {{tool}}",
    "selectChain": "เลือกเชน",
    "selectChainAndToken": "เลือกเชนและโทเค็น",
    "selectToken": "เลือกโทเคน",
    "sendToAddress": "ส่งไปยัง {{address}}",
    "sendToWallet": "ส่งไปยังกระเป๋าเงินอื่น",
    "sending": "กำลังส่ง",
    "sentToAddress": "ส่งไปยัง {{address}}",
    "stepBridge": "บริดจ์",
    "stepBridgeAndBuy": "บริดจ์และซื้อ",
    "stepDetails": "{{tool}} โดย LI.FI",
    "stepSwap": "แลกเปลี่ยน",
    "stepSwapAndBridge": "แลกเปลี่ยนและบริดจ์",
    "stepSwapAndBuy": "แลกเปลี่ยน และ ซื้อ",
    "supportId": "หมายเลขที่สนับสนุน",
    "swapStepDetails": "แลกเปลี่ยนบน {{chain}} ผ่าน {{tool}}",
    "tags": {
      "cheapest": "ราคาถูก",
      "fastest": "รวดเร็ว",
      "insurable": "การประกัน",
      "insurance": "การประกัน",
      "insured": "ประกัน",
      "recommended": "แนะนำ",
      "safest": "ปลอดภัย"
    },
    "to": "ถึง",
    "tokenOnChain": "{{tokenSymbol}} บน {{chainName}}",
    "tokenOnChainAmount": "{{amount, number(maximumFractionDigits: 9)}}{{tokenSymbol}} บน {{chainName}}",
    "tokenSearch": "ค้นหาชื่อของเหรียญ หรือ ที่อยู่",
    "valueLoss": "มูลค่าที่สูญเสีย",
    "walletAddressOrEns": "ที่อยู่กระเป๋าหรือชื่อENS"
  },
  "insurance": {
    "bridgeExploits": "การบริดจ์ทำงานผิดปกติ แฮ็กหรือหาผลประโยชน์",
    "insure": "ประกัน<0>{{amount, number(maximumFractionDigits: 9)}}{{tokenSymbol}}</0> ในการขนส่ง",
    "insured": "คุณได้ประกัน<0>{{amount, number(maximumFractionDigits: 9)}}{{tokenSymbol}}</0> ในการขนส่ง",
    "slippageError": "เกิดข้อผิดพลาดในการคลาดเคลื่อนของโทเค็นที่ได้รับ"
  },
  "settings": {
    "enabledBridges": "เปิดการใช้งานบริดจ์",
    "enabledExchanges": "เปิดการใช้งาน การแลกเปลี่ยน",
    "gasPrice": {
      "fast": "รวดเร็ว",
      "normal": "ปกติ",
      "slow": "ช้า",
      "title": "ค่าแก็ส"
    },
    "routePriority": "ลำดับสำคัญของเส้นทาง",
    "showDestinationWallet": "แสดงกระเป๋าปลายทาง",
    "slippage": "ความคลาดเคลื่อน"
  },
  "wallet": {
    "extensionNotFound": "โปรดตรวจสอบว่ามีเพียงส่วนขยายของเบราว์เซอร์ {{name}} เท่านั้นที่ใช้งานได้ก่อนที่จะเลือกกระเป๋าเงินนี้."
  }
}
